<template>
	<ConsentCheckbox
		:id="`scrolltarget-${fieldName}`"
		:name="fieldName"
		:model-value="modelValue"
		@update:model-value="handleUpdate"
		:show-errors="showErrors"
		:error-message="errorMessage"
		:tab-index="modalLoginShow ? -1 : 0"
	>
		<template #label>
			<ExpandableText
				v-if="consentTextExtended"
				:read-less-label="readLessLabel"
				:read-more-label="readMoreLabel"
				:duration="300"
			>
				<template #shortText>
					<span v-html="consentText"></span>
				</template>
				<template #longText>
					<span v-html="consentTextExtended"></span>
				</template>
			</ExpandableText>
			<DsText v-else text-type="body-sm" class="short-text">
				<span v-html="consentText"></span>
				<a v-if="url" :href="url" target="_blank" :title="urlText">
					{{ urlText }}
				</a>
			</DsText>
		</template>
	</ConsentCheckbox>
</template>

<script setup lang="ts">
import { DsText } from '@coloplast/design-system';
import { onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { validateFieldState } from 'multisite/services/checkoutHelperService';
import ConsentCheckbox from 'multisite/components/formElements/consentCheckbox.vue';
import ExpandableText from 'multisite/components/formElements/expandableText.vue';

interface Props {
	modelValue: boolean;
	showErrors: boolean;
	consentText: string;
	errorMessage: string;
	fieldName: string;
	name: string;
	consentTextExtended?: string;
	readLessLabel?: string;
	readMoreLabel?: string;
	showConsent?: boolean;
	url?: string;
	urlText?: string;
}

const props = defineProps<Props>();
const emit = defineEmits(['validate', 'update:model-value']);
const store = useStore();

const modalLoginShow = computed(() => store.getters['globalCheckout/getLoginModalShow']);

function handleUpdate(e: boolean) {
	validateField(e);
	emit('update:model-value', e);
}

function validateField(v: boolean) {
	const validateResult = validateFieldState(v, {
		required: true,
	});

	emit('validate', {
		key: props.fieldName,
		value: validateResult,
	});
}

onMounted(() => {
	validateField(props.modelValue);
});
</script>
